import { Component, ElementRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { TYPE_TOAST } from 'src/app/models/enumeraciones';
import { GoToNextStep } from 'src/app/models/utils/steps';
import { OnboardingProcessFlowService } from 'src/app/services/onboarding-process-flow.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { PreApplicationActions } from 'src/app/state/actions/pre-application.actions';
import { selectApplicantPhoneAndIsApplicantAMember } from 'src/app/state/selectors/pre-application.selectors';

@Component({
	selector: 'cmv-investment-otp-code',
	templateUrl: './investment-otp-code.component.html',
	styleUrls: ['./investment-otp-code.component.scss'],
})
export class InvestmentOtpCodeComponent implements GoToNextStep {
	isCodevalid: boolean = false;
	applicantPhoneAndIsApplicantAMember$ = this.store.select(
		selectApplicantPhoneAndIsApplicantAMember
	);
	modalContainer: string = '#cmvloadingmodal';
	acceptGeographicalLocationField: boolean = false;
	isAcceptGeographicalLocationErrorVisible: boolean = false;
	@ViewChild('acceptGeolocationInput')
	acceptGeolocationInput: ElementRef<HTMLInputElement>;

	constructor(
		private store: Store,
		private utilsService: UtilsService,
		private onboardingProcessFlowService: OnboardingProcessFlowService
	) {}

	goToNextStep(): void {
		this.onboardingProcessFlowService.goToNextStep();
	}

	onContinuar(): void {
		if (!this.isCodevalid) {
			this.utilsService.ShowToast(
				'Necesita validar el codigo que se envio a su celular',
				TYPE_TOAST.WARNING,
				10000
			);
			return;
		}

		if (!this.acceptGeographicalLocationField) {
			this.showGeographicalLocationError();
			return;
		}

		this.goToNextStep();
	}

	onHandleAcceptGeographicalLocationChange(): void {
		if (
			this.acceptGeographicalLocationField &&
			this.isAcceptGeographicalLocationErrorVisible
		) {
			this.hideAcceptGeographicalLocationError();
		}
	}

	onSuccess(otpCode: string): void {
		this.isCodevalid = true;
		this.store.dispatch(PreApplicationActions.addOtpCode({ otpCode }));
		this.acceptGeolocationInput.nativeElement.focus();
	}

	onShowEnterCodeError(error: string) {
		this.utilsService.ShowToast(error);
	}

	onShowGeneratedOtpMessage(message: string) {
		this.utilsService.ShowToast(message);
	}

	private showGeographicalLocationError() {
		this.isAcceptGeographicalLocationErrorVisible = true;
	}

	private hideAcceptGeographicalLocationError(): void {
		this.isAcceptGeographicalLocationErrorVisible = false;
	}
}
